// Game attributes that must always be stored in history-array form
// (even when there's only one entry). Used by:
//   - server/worker/core/league/loadGameAttributes.ts (runtime wrap on load)
//   - common/types.ts (AlwaysWrap union type)
//
// Defined here so common/types.ts can reference it without crossing into
// server/.

import type { GameAttributesLeague } from "./types.ts";

export const ALWAYS_WRAP = [
	"confs",
	"divs",
	"maxOvertimes",
	"numGames",
	"numGamesPlayoffSeries",
	"numPlayoffByes",
	"otl",
	"playoffsNumTeamsDiv",
	"pointsFormula",
	"shootoutRounds",
	"tiebreakers",
	"userTid",
] as const satisfies (keyof GameAttributesLeague)[];
